<template>
  <div>
    <staging-menu title="Lawn Maintenance"></staging-menu>
    <staging-table :table_title='table_title' table_icon='mdi-grass' :staging_projects='staging_projects'
      :column_headers='column_headers' :stats='stats' :length='length' @filter='filter'
      :disable_meter_pits_filter='true' @viewStagingProject='viewStagingProject'
      @updateStagingProject='updateStagingProject' />
    <staging-project v-if='selected_project !== null' :staging_project_id='selected_project.id'
      :show_dialog='show_dialog' :timeline_items='timeline_items' :stage_items='stage_items' @close='closeDialog'
      @open='openProject' @updateStagingProject='updateStagingProject' @cancelStaging='cancelStaging' icon='mdi-grass'
      @nextProject='nextStagingProject' @prevProject='prevStagingProject' icon_color='green'>
    </staging-project>
  </div>
</template>

<script>
import stagingAPI from '@/api/staging';
import Menu from './common/Menu';
import Table from './common/Table';
import StagingProject from './common/StagingProject';

export default {
  name: 'lawn-maintenance-staging-base',
  data: () => ({
    year: new Date().getFullYear(),
    staging_projects: [],
    selected_project: null,
    show_dialog: false,
    stats: {},
    length: 0,
    timeline_items: [
      {
        text: 'Early Spring Cleanup',
        value: 'QUP'
      },
      {
        text: 'No Timeline',
        value: 'NTL'
      }
    ],
    stage_items: [
      {
        text: 'Ready for Contact',
        value: 1
      },
      {
        text: 'Ready for Offer',
        value: 2
      },
      {
        text: 'Ready for Confirmation',
        value: 3
      }
    ],
    column_headers: [
      'Ready for Contact',
      'Ready for Offer',
      'Ready for Confirmation',
      'Activated'
    ]
  }),
  mounted() {
    if (this.$route.params.year) {
      this.year = this.$route.params.year;
    }
    this.getData();
  },
  computed: {
    table_title() {
      return this.year + " Lawn Maintenance Staging";
    }
  },
  methods: {
    async getData() {
      const dashboard = await stagingAPI.getDashboard(this.year, this.year, this.year, this.year, this.year);
      this.stats = dashboard.lawn_maintenance_data;
      const data = await stagingAPI.getLawnMaintenance(this.year, 1, {});
      this.staging_projects = data.results;
      this.length = data.count;
    },
    viewStagingProject(staging_project) {
      this.selected_project = staging_project;
      this.show_dialog = true;
    },
    closeDialog() {
      this.show_dialog = false;
    },
    openProject(project) {
      const link = document.createElement('a')
      const invURL = this.$router.resolve({ name: 'LawnOverview', params: { id: project.id } })
      link.target = '_blank'
      link.href = invURL.href
      link.click()
    },
    async filter(page, filters) {
      const data = await stagingAPI.getLawnMaintenance(this.year, page, filters);
      this.staging_projects = data.results;
      this.length = data.count;
    },
    nextStagingProject() {
      for (let i = 0; i < this.staging_projects.length; i++) {
        if (this.staging_projects[i].id === this.selected_project.id) {
          this.selected_project = this.staging_projects[i + 1] ? this.staging_projects[i + 1] : this.staging_projects[0];
          break;
        }
      }
    },
    prevStagingProject() {
      for (let i = 0; i < this.staging_projects.length; i++) {
        if (this.staging_projects[i].id === this.selected_project.id) {
          this.selected_project = this.staging_projects[i - 1] ? this.staging_projects[i - 1] : this.staging_projects[this.staging_projects.length - 1];
          break;
        }
      }
    },
    updateStagingProject(returned_projects) {
      for (let i = 0; i < this.staging_projects.length; i++) {
        if (returned_projects.length < 1) {
          break;
        }
        for (let j = 0; j < returned_projects.length; j++) {
          if (this.staging_projects[i].id === returned_projects[j].id) {
            this.staging_projects.splice(i, 1, returned_projects[j]);
            returned_projects.splice(j, 1);
            break;
          }
        }
      }
    },
    cancelStaging(id) {
      stagingAPI.cancelStaging(id);
      this.staging_projects.map((staging_project) => {
        if (staging_project.id === id) {
          const index = this.staging_projects.indexOf(staging_project);
          staging_project.resolved = true;
          staging_project.resolution = 'D';
          staging_project.work_order_to_project_data = [];
          this.staging_projects.splice(index, 1, staging_project);
          return;
        }
      });
    }
  },
  components: {
    'staging-menu': Menu,
    'staging-table': Table,
    'staging-project': StagingProject
  }
}
</script>
